import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ISolicitudPersonaDocumentoValidarModel } from 'src/app/models/commands/solicitudes/solicitud-persona/interfaces/ISolicitudPersonaDocumentoValidarModel';
import { DocumentoResult } from 'src/app/models/common/DocumentoResult';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ISolicitudPersonaValidarModel } from 'src/app/models/interfaces/solicitud/personal/ISolicitudPersonaValidarModel';
import { FilterSolicitudPersonaRenovarDocumentoModel } from 'src/app/models/queries/solicitudes/solicitud-persona/FilterSolicitudPersonaRenovarDocumento';
import { FilterSolicitudPersonaValidarRenovacionDocumentoModel } from 'src/app/models/queries/solicitudes/solicitud-persona/FilterSolicitudPersonaValidarRenovacionDocumento';
import { SolicitudPersonaDocumentoPorValidarRenovacionModel } from 'src/app/models/queries/solicitudes/solicitud-persona/SolicitudPersonaDocumentoPorValidarRenovacionModel';
import { SolicitudPersonaDocumentoPorVencerModel } from 'src/app/models/queries/solicitudes/solicitud-persona/SolicitudPersonaDocumentoPorVencerModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SolicitudPersonaDocumentosService {
  private configUrl = [environment.apiGatewayUrl, 'solicitudes'].join('/');

  constructor(
    private http: HttpClient,
    private datepipe: DatePipe
    ) { }

  guardar(formData: FormData, codigo: string, idSolicitud: number){ //model: ISolicitudCompletarModel
    return this.http.post(`${this.configUrl}/${idSolicitud}/personas/documentos/${codigo}/upload`, formData, {reportProgress: true, observe: 'events'});
  }

  renovar(formData: FormData, idSolicitudPersonaDocumento: number, idSolicitud: number){ //model: ISolicitudCompletarModel
    return this.http.post(`${this.configUrl}/${idSolicitud}/personas/documentos/${idSolicitudPersonaDocumento}/renovar`, formData, {reportProgress: true, observe: 'events'});
  }

  validar(model: ISolicitudPersonaDocumentoValidarModel){
    return this.http.post<ISolicitudPersonaDocumentoValidarModel>(`${this.configUrl}/personas/documentos/validar`, model);
  }

  getListDocumentosPorVencerPorContratista(
    model: FilterSolicitudPersonaRenovarDocumentoModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<SearchResultModel<SolicitudPersonaDocumentoPorVencerModel[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${model.codigoSolicitud}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicio=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFin=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }
    
    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }
    
    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`); 
    }

    return this.http.get<SearchResultModel<SolicitudPersonaDocumentoPorVencerModel[]>>(
      `${this.configUrl}/contratista/documentos-por-vencer` + '?'+ queryParams.join('&')
    );
  }

  getListDocumentosPorVencerPorContratistaToExport(
    model: FilterSolicitudPersonaRenovarDocumentoModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${model.codigoSolicitud}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicio=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFin=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }
    
    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }
    
    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`); 
    }

    return this.http.get(
      `${this.configUrl}/contratista/documentos-por-vencer/exportar` + '?'+ queryParams.join('&'), { responseType: 'blob'} 
    );
  }

  getListDocumentosPorValidarRenovacion(
    model: FilterSolicitudPersonaValidarRenovacionDocumentoModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<SearchResultModel<SolicitudPersonaDocumentoPorValidarRenovacionModel[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${model.codigoSolicitud}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicio=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFin=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }
    
    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }
    
    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`); 
    }

    return this.http.get<SearchResultModel<SolicitudPersonaDocumentoPorValidarRenovacionModel[]>>(
      `${this.configUrl}/personas/documentos-por-validar-renovacion` + '?'+ queryParams.join('&')
    );
  }
  
  getListDocumentosPorValidarRenovacionToExport(
    model: FilterSolicitudPersonaValidarRenovacionDocumentoModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (model.nombreEmpleado !== '') {
      queryParams.push(`empleado=${model.nombreEmpleado}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if (model.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${model.codigoSolicitud}`);
    }

    if (model.nombreContratista !== '') {
      queryParams.push(`contratista=${model.nombreContratista}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicio=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFin=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }
    
    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }
    
    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`); 
    }

    return this.http.get(
      `${this.configUrl}/personas/documentos-por-validar-renovacion/exportar` + '?'+ queryParams.join('&'), { responseType: 'blob' }
    );
  }

  downloadDocumento(codigoSolicitud: string, idSolicitudPersona: number, id: number): Observable<Blob> {
    return this.http.get(`${this.configUrl}/${codigoSolicitud}/personas/${idSolicitudPersona}/documentos/${id}/download`, { responseType: 'blob' });
  }
  
  downloadasStringDocumento(codigoSolicitud: string, idSolicitudPersona: number, id: number): Observable<DocumentoResult> {
    return this.http.get<DocumentoResult>(`${this.configUrl}/${codigoSolicitud}/personas/${idSolicitudPersona}/documentos/${id}/downloadbase64`);
  }
}
